export const POSITION_ROLE = '/position/';
